import { render, staticRenderFns } from "./ApprovalCompleted.vue?vue&type=template&id=390fe552&scoped=true&"
import script from "./ApprovalCompleted.vue?vue&type=script&lang=js&"
export * from "./ApprovalCompleted.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalCompleted.vue?vue&type=style&index=0&id=390fe552&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390fe552",
  null
  
)

export default component.exports